import * as React from "react";
import { formatAmount, Payment } from "@graffer-inc/cloud-gov-core";

export type PaymentSummaryV2Props = {
  payment: Pick<
    Payment,
    "amount" | "amountDetail" | "taxAmountDetail" | "amountRefunded"
  > & {
    adjustmentRequiredDetail?: {
      exceeding?: number | null;
      deficiency?: number | null;
    } | null;
  };
};

export const PaymentSummaryV2: React.FC<PaymentSummaryV2Props> = ({
  payment,
}) => {
  return (
    <div className="columns mt-2 px-3">
      <div className="column is-three-fifth" />
      <div className="column">
        {/* 合計決済額・返済額 */}
        {payment.amountRefunded > 0 && (
          <div>
            <div className="columns mt-2">
              <div className="column is-flex py-0 is-size-4-mobile is-size-6-desktop">
                <span style={{ marginTop: "auto" }}>支払額</span>
              </div>
              <div className="column py-0 has-text-right">
                <span className="is-size-3-mobile is-size-4-desktop">
                  {formatAmount(payment?.amount + payment?.amountRefunded)}
                </span>
                <span className="ml-1 is-size-6">円</span>
              </div>
            </div>
            <div className="columns">
              <div className="column is-flex py-0 is-size-4-mobile is-size-6-desktop">
                <span style={{ marginTop: "auto" }}>返金額</span>
              </div>
              <div className="column py-0 has-text-right">
                <span className="is-size-4-mobile is-size-4-desktop">
                  - {formatAmount(payment?.amountRefunded)}
                </span>
                <span className="ml-1 is-size-6">円</span>
              </div>
            </div>
            <div style={{ borderTop: "1px solid lightgrey" }} />
          </div>
        )}
        {/* 合計金額 */}
        <div className="columns my-0 has-text-weight-bold">
          <div className="column is-4 is-flex is-size-4-mobile is-size-4-desktop">
            <span style={{ marginTop: "auto" }}>合計</span>
          </div>
          <div className="column is-8 py-1 has-text-right">
            <span className="is-size-3-mobile is-size-3-desktop">
              {formatAmount(payment?.amount)}
            </span>
            <span className="ml-1 is-size-6">円</span>
          </div>
        </div>
        {/* 内訳 */}
        {(payment.amountDetail["0"] > 0 ||
          payment.amountDetail["0.1"] > 0 ||
          payment.amountDetail["0.08"] > 0) && (
          <div style={{ borderTop: "1px solid lightgrey" }} />
        )}
        <div className="columns mt-0">
          <div className="column py-0">
            {payment.amountDetail["0"] > 0 && (
              <div className="columns mt-2 mb-0">
                <div className="column py-0">
                  <span>非課税</span>
                </div>
                <div className="column py-0 has-text-right">
                  <span>{formatAmount(payment.amountDetail["0"])}</span>
                  <span className="ml-1 is-size-6">円</span>
                </div>
              </div>
            )}
            {payment.amountDetail["0.1"] > 0 && (
              <div className="columns mt-2 mb-0">
                <div className="column py-0">
                  <span>税率10%対象</span>
                </div>
                <div className="column py-0 has-text-right">
                  <span>{formatAmount(payment.amountDetail["0.1"])}</span>
                  <span className="ml-1 is-size-6">円</span>
                </div>
              </div>
            )}
            {payment.taxAmountDetail["0.1"] > 0 && (
              <div className="columns my-0 has-text-grey">
                <div className="column py-0">
                  <span>うち税額</span>
                </div>
                <div className="column py-0 has-text-right">
                  <span>{formatAmount(payment.taxAmountDetail["0.1"])}</span>
                  <span className="ml-1 is-size-6">円</span>
                </div>
              </div>
            )}
            {payment.amountDetail["0.08"] > 0 && (
              <div className="columns mt-2 mb-0">
                <div className="column py-0">
                  <span>税率8%対象</span>
                </div>
                <div className="column py-0 has-text-right">
                  <span>{formatAmount(payment.amountDetail["0.08"])}</span>
                  <span className="ml-1 is-size-6">円</span>
                </div>
              </div>
            )}
            {payment.taxAmountDetail["0.08"] > 0 && (
              <div className="columns my-0 has-text-grey">
                <div className="column py-0">
                  <span>うち税額</span>
                </div>
                <div className="column py-0 has-text-right">
                  <span>{formatAmount(payment.taxAmountDetail["0.08"])}</span>
                  <span className="ml-1 is-size-6">円</span>
                </div>
              </div>
            )}
            {payment.adjustmentRequiredDetail &&
              !!payment.adjustmentRequiredDetail.deficiency &&
              payment.adjustmentRequiredDetail.deficiency > 0 && (
                <div className="columns mt-2 mb-0">
                  <div className="column py-0">
                    <span>入金不足</span>
                  </div>
                  <div className="column py-0 has-text-right">
                    <span>
                      {formatAmount(
                        payment.adjustmentRequiredDetail.deficiency,
                      )}
                    </span>
                    <span className="ml-1 is-size-6">円</span>
                  </div>
                </div>
              )}
            {payment.adjustmentRequiredDetail &&
              !!payment.adjustmentRequiredDetail.exceeding &&
              payment.adjustmentRequiredDetail.exceeding > 0 && (
                <div className="columns mt-2 mb-0">
                  <div className="column py-0">
                    <span>過入金</span>
                  </div>
                  <div className="column py-0 has-text-right">
                    <span>
                      {formatAmount(payment.adjustmentRequiredDetail.exceeding)}
                    </span>
                    <span className="ml-1 is-size-6">円</span>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
